Vue.component('frame-upload', {
  template: templates.frameUpload,
  props: {
    frameId: {
      type: String,
      required: true
    },
    uploadType: {
      type: String,
      required: true,
      validator: value => ['frame', 'background'].includes(value)
    },
    validateRatio: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      selectedFile: null,
      previewUrl: null,
      dragOver: false,
      uploadProgress: {
        active: false,
        percent: 0
      },
      validationMessage: null
    }
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        this.processFile(files[0]);
      }
    },

    handleDragEnter(event) {
      event.preventDefault();
      this.dragOver = true;
    },

    handleDragOver(event) {
      event.preventDefault();
    },

    handleDragLeave(event) {
      event.preventDefault();
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.dragOver = false;
      }
    },

    handleFileDrop(event) {
      event.preventDefault();
      this.dragOver = false;

      const files = event.dataTransfer.files;
      if (files && files.length > 0) {
        this.processFile(files[0]);
      }
    },

    async processFile(file) {
      const c = this;
      c.validationMessage = null;

      // Validate file type
      if (!file.type.startsWith('image/')) {
        c.validationMessage = 'Please select an image file (PNG, JPG, or WebP)';
        return;
      }

      // Validate file size (10MB max)
      if (file.size > 10 * 1024 * 1024) {
        c.validationMessage = 'File size must be less than 10MB';
        return;
      }

      // Get image dimensions (for display purposes only, no validation)
      c.getImageDimensions(file);

      // File is valid, set it
      c.selectedFile = file;
      c.createPreview(file);
    },

    getImageDimensions(file) {
      const c = this;

      const img = new Image();
      const url = URL.createObjectURL(file);

      img.onload = function() {
        // Store dimensions for upload
        c.fileDimensions = {
          width: this.width,
          height: this.height
        };
        URL.revokeObjectURL(url);
      };

      img.onerror = function() {
        URL.revokeObjectURL(url);
      };

      img.src = url;
    },

    createPreview(file) {
      const c = this;

      const reader = new FileReader();
      reader.onload = (e) => {
        c.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    clearFile() {
      const c = this;
      c.selectedFile = null;
      c.previewUrl = null;
      c.validationMessage = null;

      // Safely clear file input if it exists
      if (c.$refs.fileInput) {
        c.$refs.fileInput.value = '';
      }
    },

    async uploadFile() {
      const c = this;

      if (!c.selectedFile) {
        return;
      }

      c.uploadProgress.active = true;
      c.uploadProgress.percent = 0;

      try {
        const formData = new FormData();
        formData.append('file', c.selectedFile);
        formData.append('id', c.frameId);

        // Add dimensions if available
        if (c.fileDimensions) {
          formData.append('width', c.fileDimensions.width);
          formData.append('height', c.fileDimensions.height);
        }

        // Use the correct API endpoint based on upload type
        const uploadUrl = c.uploadType === 'background'
          ? '/api/background/upload.php'
          : '/api/frame/upload.php';

        const response = await axios.post(uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              c.uploadProgress.percent = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            }
          }
        });

        c.uploadProgress.active = false;

        if (response.data && response.data.success) {
          // Emit the correct event based on upload type
          const eventName = c.uploadType === 'background'
            ? 'background-upload-success'
            : 'frame-upload-success';

          c.$root.$emit(eventName, {
            id: c.frameId,
            type: c.uploadType,
            filename: response.data.filename,
            path: response.data.path
          });

          // Clear the file
          c.clearFile();

          utils.alert.success(`${c.uploadType === 'frame' ? 'Frame' : 'Background'} uploaded successfully!`);
        } else {
          throw new Error(response.data.error || 'Upload failed');
        }

      } catch (error) {
        c.uploadProgress.active = false;
        console.error('Upload error:', error);

        const errorMessage = error.response?.data?.error || error.message || 'Upload failed';
        utils.alert.error(errorMessage);
      }
    }
  }
});
